'use strict';

import TaskAssignment from './taskAssignment/TaskAssignment.service'

const state = {}

const actions = {
  ...TaskAssignment.actions,
}

const mutations = {}

const getters = {}

export default { getters, actions, mutations, state }